import { Fragment } from 'react'

import Popup from '@/ui/Popup'
import { GlobalStyle, StyledIcon, type IconProps } from './Styles'

const Icon = ({
  title,
  disabled,
  onClick,
  popupPosition = 'top left',
  popupOffset,
  ...props
}: IconProps) => {
  const IconNode = (
    <StyledIcon
      disabled={disabled}
      onClick={!disabled ? onClick : undefined}
      {...props}
    />
  )

  return (
    <Fragment>
      <GlobalStyle />

      {title ? (
        <Popup
          inverted
          className="no-pointer-events"
          position={popupPosition}
          offset={popupOffset ?? [-10, -5]}
          content={title}
          trigger={<span>{IconNode}</span>}
        />
      ) : (
        IconNode
      )}
    </Fragment>
  )
}

export default Icon
